import axios from "axios";
import history from "../history";
import Cookies from "js-cookie";
import { URL_AKM } from "../config";

var url = window.location.pathname;
var token = Cookies.get("Set-Cookie");

var header = {};

// if( token === undefined || token === null )
//     history.push('/login')

if (!url.includes("register-psep")) {
    header = {
        Accept: "application/json",
        "Content-Type": "application/json",
    };
} else {
    if (token === undefined || token === null) {
        history.push("/login");
    } else {
        header = {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
        };
    }
}

const instance = axios.create({
    baseURL: URL_AKM.AKM_HOST,
    headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
    },
});

instance.defaults.withCredentials = false;
instance.interceptors.response.use(
    (response) => {
        return response;
    },
    (error) => {
        console.log(error);
        Cookies.remove("Set-Cookie");
        history.push("/login");
    }
);

export default instance;
